import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PifDiscountInfo } from '@models/billing';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-disclaimers',
  templateUrl: './disclaimers.component.html',
  styleUrls: ['./disclaimers.component.scss']
})
export class DisclaimersComponent implements OnChanges {

  @Input() policy?: any;
  @Input() policies?: any[];
  @Input() url?: string;

  showOutstandingBalance = false;
  showPif = false;
  showMinAmtDue = false;
  showAny = false;
  currUrl: any
  isAcmic: boolean;

  constructor(private router: Router, private acmicService: AcmicService,){
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnChanges(changes: SimpleChanges): void {
    void changes;
    const allPolicies = this.resolvedPolicies();
    this.currUrl = this.url ?? this.router.url;
    const isBillingScr = this.currUrl.includes("billing-new") && this.currUrl.includes("details");
    const isMakeAPaymentScr = this.currUrl.includes("billing-new") && this.currUrl.includes("make-a-payment");

    if(isMakeAPaymentScr){
      this.loadDisclaimersMakeAPayment(allPolicies);
    } else if(isBillingScr){
      this.loadDisclaimersBillingDetails(allPolicies);
    } else {
      this.loadDisclaimersMyInsurance(allPolicies);
    }

    this.showAny = this.showOutstandingBalance || this.showPif || this.showMinAmtDue;
  }

  private resolvedPolicies(): any[] {
    if (this.policies?.length) return this.policies;
    if (this.policy) return [this.policy];
    return [];
  }

  private loadDisclaimersMakeAPayment(allPolicies: any[]){
    this.showMinAmtDue = false;
    this.showPif = false;
    
    this.showOutstandingBalance = allPolicies.some(p => !p?.hasAffinityGroup);
  }

  private loadDisclaimersBillingDetails(allPolicies: any[]){
    this.showOutstandingBalance = allPolicies.some(p => !p?.hasAffinityGroup)

    this.showPif = allPolicies.some(p => {
      const pif: PifDiscountInfo = p?.pifDiscountInfo;
      return pif?.pifEligible && !pif?.isPaidInFull;
    });

    this.showMinAmtDue = allPolicies.some(p => {
        const billing = p?.billingDetails?.[0];
        const priorYearAmt = p?.priorYearBalance?.theAmount ?? 0;
        const outstandingBalance = p?.hasPriorYearBalance
          ? billing.outstandingbalance + priorYearAmt
          : billing.outstandingbalance;
        return outstandingBalance > 0;
      }
    );
  }

  private loadDisclaimersMyInsurance(allPolicies){
    this.showOutstandingBalance = allPolicies.some(p => this.showOutBalanceDisclaimer(p));

    this.showPif = allPolicies.some(p => {
      const pif: PifDiscountInfo = p?.pifDiscountInfo;
      return pif?.pifEligible && !pif?.isPaidInFull;
    });

    this.showMinAmtDue = allPolicies.some(p =>
     this.hasOutstandingBilling(p)
    );
  }

  private hasOutstandingBilling(policy: any): boolean {
    const billing = policy?.billingDetails?.[0];
    if (!billing) return false;

    const hasRawOutstanding = billing.outstandingbalance != 0 ||
                              billing.amountStillDue > 0 ||
                              billing.priorYearBalance > 0;
    return  billing.outstandingbalance > 0 
              || ((policy.calculatedBalanceDetails?.outstandingBalance !== 0 || policy.policyStatus == 'FUTURE' || policy.policyStatus == 'ACTIVE')
                  && (billing.paymentDueDate || policy?.calculatedBalanceDetails?.currentMinAmtDue === 0)
                  && hasRawOutstanding);
    }

  private showOutBalanceDisclaimer(policy: any): boolean{
   if(!policy?.billingDetails?.[0]) return false;

    if (!policy.calculatedBalanceDetails) {
      return !!policy.pifDiscountInfo?.isPaidInFull || !policy.billingDetails[0];
    }

    return !!policy.pifDiscountInfo?.isPaidInFull
      || policy.calculatedBalanceDetails.outstandingBalance !== 0
      || policy.calculatedBalanceDetails.currentMinAmtDue !== 0;
  }
}
